module.exports = __webpack_public_path__ + "img/3.90544236.png";